// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "img[data-v-638eb21c]{display:inline-block}div a[data-v-638eb21c]{color:#4e68c6;font-size:14px}@media(prefers-color-scheme:dark){div a[data-v-638eb21c]{color:#fff}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
